(() => {
  const LOG = "[JP FastBundle SubDefault]";
  const PLAN_ID = "690809536844"; // 30-day subscription plan id
  const DEBUG = true;

  const log = (...a) => DEBUG && console.log(LOG, ...a);

  // find the FastBundle purchase-type <select> inside the modal (or anywhere)
  function findBundleSelect(root = document) {
    const selects = [...root.querySelectorAll("select")];
    return selects.find(sel => {
      const texts = [...sel.options].map(o => (o.textContent || "").toLowerCase());
      return texts.some(t => t.includes("one time")) && texts.some(t => t.includes("subscription"));
    }) || null;
  }

  function setDefaultSubscriptionOnce(modal) {
    if (!modal) return false;

    // Guard: run once per modal-open session
    if (modal.dataset.jpSubDefaultApplied === "1") return true;

    const sel = findBundleSelect(modal) || findBundleSelect(document);
    if (!sel) return false;

    // If it's already set, mark and exit
    if (String(sel.value) === PLAN_ID) {
      modal.dataset.jpSubDefaultApplied = "1";
      log("Already on 30-day ✅");
      return true;
    }

    // Only set if that option exists
    const hasPlan = [...sel.options].some(o => String(o.value) === PLAN_ID);
    if (!hasPlan) {
      log("Plan option not present in select (yet).");
      return false;
    }

    sel.value = PLAN_ID;
    sel.dispatchEvent(new Event("input", { bubbles: true }));
    sel.dispatchEvent(new Event("change", { bubbles: true }));

    modal.dataset.jpSubDefaultApplied = "1";
    log("Set default subscription ✅", PLAN_ID);
    return true;
  }

  function getOpenModal() {
    // Fast Bundle modal commonly uses role="dialog"
    const dialogs = [...document.querySelectorAll('[role="dialog"]')];
    // choose a visible one
    return dialogs.find(d => {
      const st = getComputedStyle(d);
      return st.display !== "none" && st.visibility !== "hidden" && st.opacity !== "0";
    }) || null;
  }

  function runWhenModalReady() {
    const modal = getOpenModal();
    if (!modal) return;

    // try now
    if (setDefaultSubscriptionOnce(modal)) return;

    // if not ready yet, retry a few times while it renders
    let tries = 0;
    const maxTries = 25; // ~5s
    const timer = setInterval(() => {
      const m = getOpenModal();
      if (!m) return clearInterval(timer);

      tries++;
      const ok = setDefaultSubscriptionOnce(m);
      if (ok || tries >= maxTries) clearInterval(timer);
    }, 200);
  }

  // 1) Run after your chip click (best signal)
  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-jp-fastbundle-trigger], .jp-bundle-chip")) {
      // reset flag for next open
      const modal = getOpenModal();
      if (modal) delete modal.dataset.jpSubDefaultApplied;
      setTimeout(runWhenModalReady, 250);
    }
  });

  // 2) Also detect modal opening via mutations (covers other entry points)
  const mo = new MutationObserver(() => {
    const modal = getOpenModal();
    if (!modal) return;

    // if modal re-opened, allow one run again
    if (modal.dataset.jpSeenOpen !== "1") {
      modal.dataset.jpSeenOpen = "1";
      delete modal.dataset.jpSubDefaultApplied;
      setTimeout(runWhenModalReady, 250);
    }
  });

  mo.observe(document.documentElement, { childList: true, subtree: true });

  log("Loaded ✅");
})();